import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'personalName',
})
export class PersonalNamePipe implements PipeTransform {
  transform(
    value: string | undefined,
    ...args: (string | undefined)[]
  ): string {
    return [value, ...args]
      .map((s) => (s ?? '').trim())
      .filter((s) => s)
      .join(' ');
  }
}
